export const SIMULATOR_PATH = '/simulateur/bilan'
export const FAQ_PATH = '/questions-frequentes'
export const POLL_START_PATH = '/infos/commencer'
export const POLL_EMAIL_STEP = '/infos/email'
export const POLL_POSTAL_CODE_STEP = '/infos/codepostal'
export const POLL_BIRTHDAY_STEP = '/infos/naissance'
export const END_PAGE_PATH = '/fin'
